import { render, staticRenderFns } from "./green-menu.vue?vue&type=template&id=eb73c8f2&"
import script from "./green-menu.vue?vue&type=script&lang=js&"
export * from "./green-menu.vue?vue&type=script&lang=js&"
import style0 from "./green-menu.vue?vue&type=style&index=0&id=eb73c8f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports